module.exports = __webpack_public_path__ + "img/symbol_color.7098f5bb.svg";